import { tI18nDefinition } from "oweb";

export default {
	"OO_LANG_NEW_VERSION_EXISTS": "Une nouvelle version ({new_version}) de {app_name} existe.",
	"OO_LANG_APP_UPDATE": "Mettre à jour",
	"OO_LANG_APP_UPDATE_IGNORE": "Ignorer",
	"OO_LANG_LOGIN": "Se connecter",
	"OO_LANG_SIGNUP": "Créer un compte",
	"OO_LANG_LOGOUT": "Se déconnecter",
	"OO_LANG_PASSWORD": "Mot de passe",
	"OO_LANG_CONFIRM_PASSWORD": "Confirmer le mot de passe",
	"OO_LANG_CURRENT_PASSWORD": "Mot de passe actuel",
	"OO_LANG_NEW_PASSWORD": "Nouveau mot de passe",
	"OO_LANG_CONFIRM_NEW_PASSWORD": "Confirmer le nouveau mot de passe",
	"OO_LANG_PHONE": "Numéro",
	"OO_LANG_EMAIL": "E-mail (Facultatif)",
	"OO_LANG_VALIDATE_BTN": "Valider",
	"OO_LANG_CHECK_BTN": "Vérifier",
	"OO_LANG_VERIFICATION_CODE": "Code de vérification",
	"OO_LANG_ENTER_CODE": "Entrez le code",
	"OO_LANG_MALE": "Masculin",
	"OO_LANG_FEMALE": "Féminin",
	"OO_LANG_SEX": "Sexe",
	"OO_LANG_USER_NAME": "Nom et Prénoms",
	"OO_LANG_BIRTH_DATE": "Date de naissance",
	"OO_LANG_CONNECT": "Se connecter",
	"OO_LANG_REGISTER": "S'inscrire",
	"OO_LANG_ACCOUNT_RECOVERY": "Récupération du compte",
	"OO_LANG_DO_ACCOUNT_RECOVERY": "Récupérer mon compte",
	"OO_LANG_DO_YOU_HAVE_ACCOUNT": "Avez-vous déjà un compte?",
	"OO_LANG_DO_NOT_HAVE_ACCOUNT": "Vous n'avez pas de compte?",
	"OO_LANG_PASSWORD_FORGOTTEN": "Mot de passe oublier?",
	"OO_LANG_ACCEPT_CGU": "J'accepte les <a class=\"ux-link\" href=\"javascript:void 0;\" target=\"_blank\"> CGU </a>",

	"OO_LANG_PASS_EDIT": "Changer le mot de passe",
	"OO_LANG_EDIT": "Modifier",
	"OO_LANG_DELETE": "Supprimer",

	// =================================================================================

	"OZ_ERROR_REQUEST_FAIL": "Connexion perdu, merci de vous connecter.",
	"OZ_ERROR_NETWORK": "Connexion perdu, merci de vous connecter.",
	"OZ_ERROR_SERVER": "Connexion perdu, merci de vous connecter.",

	"OZ_ERROR_SHOULD_ACCEPT_CGU": "Vous devez accepter les Conditions Générales d'Utilisation.",

	"SX_LANG_LOGIN": "Connectez-vous",
	"SX_LANG_SIGNUP": "Inscription",

	"SX_LANG_HOME": "Accueil",
	"SX_LANG_SECTORS": "Secteurs",
	"SX_LANG_ABOUT": "À propos",
	"SX_LANG_SHARE": "Partager",
	"SX_LANG_SEARCH": "Rechercher",
	"SX_LANG_SURVEYS": "Enquêtes & Sondages",
	"SX_LANG_SURVEY_ADD": "Ajouter une Enquêtes",
	"SX_LANG_SURVEY_EDIT": "Modifier",
	"SX_LANG_COMPANY_EDIT": "Modifier",
	"SX_LANG_COMPANY_ADD": "Ajouter une société",
	"SX_LANG_SECTOR_ADD": "Ajouter un secteur",
	"SX_LANG_SECTOR_EDIT": "Modifier",

	"SX_LANG_SURVEY_BUILDER": "Composer l'enquête",
	"SX_LANG_SURVEY_RUN": "Démarrer",
	"SX_LANG_CHOOSE_PIC": "Choisir une image",
	"SX_LANG_PIC_EDIT_NOTICE": "Veuillez sélectionner une image.",
	"SX_LANG_PIC_EDIT_SAVE": "Sauvegarder",

	"SX_LANG_DOWNLOAD_XLS": "Télécharger au format XLS",
	"SX_LANG_DOWNLOAD_PDF": "Télécharger au format PDF",

	"SX_LANG_SECTOR": "Secteur",
	"SX_LANG_NAME": "Nom",
	"SX_LANG_DESCRIPTION": "Description",
	"SX_LANG_VISIBILITY": "Public",
	"SX_LANG_QUESTION_LABEL": "Question",
	"SX_LANG_QUESTION_SUB_LABEL": "Description",

	"SX_LANG_ANSWERS_COUNT": "{count} réponse ~ {count} réponses",
	"SX_LANG_COMPANY_PIC_EDIT": "Changer le logo",

	"SX_LANG_SAVE": "Enrégistrer",
	"SX_LANG_ADD_CHOICE": "Ajouter",
	"SX_LANG_ADD_OTHERS_CHOICE": "Ajouter le champ dynamique `Autres`",
	"SX_LANG_QUESTION_TYPE": "Type",
	"SX_LANG_QUESTION_TYPE_TEXT": "Texte",
	"SX_LANG_QUESTION_TYPE_RADIO": "Choix unique",
	"SX_LANG_QUESTION_TYPE_CHECKBOX": "Cases à cochées",
	"SX_LANG_QUESTION_TYPE_BIGTEXT": "Zone de texte",
	"SX_LANG_OTHERS_CHOICE": "Autres",
	"SX_LANG_OTHERS_PRECISE": "Précisez",
	"SX_LANG_SURVEY_STATS": "Statistiques",
	"SX_LANG_ANSWERS_STATS_ERROR": "Statistiques non disponibles, réessayez plus tard.",

	"SX_LANG_QUESTION_ADD": "Ajouter une question",
	"SX_LANG_SURVEY_IS_DIRTY": "Certaines questions ne sont pas valide.",
	"SX_LANG_SURVEY_QUESTIONS_SAVED": "Enrégistrer avec succès.",
	"SX_LANG_SURVEY_QUESTIONS_SAVE_FAIL": "Échec de la sauvegarde.",

	"SX_LANG_CHOICES_MIN_COUNT": "Choix minimum",
	"SX_LANG_CHOICES_MAX_COUNT": "Choix maximum",
	"SX_LANG_CHARS_MIN_LENGTH": "Caractères minimum",
	"SX_LANG_CHARS_MAX_LENGTH": "Caractères maximum",
	"SX_LANG_REQUIRED": "Obligatoire",
	"SX_LANG_BACK": "Précédent",
	"SX_LANG_NEXT": "Suivant",
	"SX_LANG_DUPLICATE": "Dupliqué",
	"SX_LANG_WRITE": "Écrire...",

	"SX_LANG_BG_COLOR": "Couleur de fond",
	"SX_LANG_TXT_COLOR": "Couleur de text",

	"SX_LANG_SURVEY_USER_INFO_TITLE": "Votre numéro s'il vous plait.",
	"SX_LANG_SURVEY_COMPLETED": "Merci d'avoir participé à cette enquête.",
	"SX_LANG_SURVEY_ANSWERS": "Réponses",
	"SX_LANG_SURVEY_UNSENT_ANSWERS": "Réponses non envoyées",
	"SX_LANG_ANSWERS_SEND_UNSENT": "Synchroniser",
	"SX_LANG_ANSWERS_COPY_UNSENT": "Copier",
	"SX_LANG_COPY_TO_CLIPBOARD_DONE": "Copié dans le presse-papiers!",
	"SX_LANG_COPY_TO_CLIPBOARD_ERROR": "Erreur lors de la copie vers le presse-papiers!",
	"SX_LANG_ANSWERS_UNSENT_EMPTY": "Aucune réponse en attente d'être envoyé.",
	"SX_LANG_ANSWERS_LIST_EMPTY": "Il n'y a aucune réponse disponible pour le moment.",

	"SX_LANG_REQUIRE_USER": "Pour les utilisateurs de SondXpress uniquement",

	"SX_LANG_SURVEY_HAS_NO_QUESTION": "Cette enquête ne comporte aucune question, il est probablement en cours d'édition.",
	"SX_LANG_SURVEY_NOT_FOUND": "Erreur lors de l'affichage de l'enquête.",
	"SX_LANG_SECTOR_NOT_FOUND": "Erreur lors de l'affichage du secteur.",
	"SX_LANG_COMPANY_NOT_FOUND": "Erreur lors de l'affichage de la société.",
	"SX_LANG_SECTORS_LIST_EMPTY": "La liste des secteurs est vide.",
	"SX_LANG_SECTOR_COMPANIES_LIST_EMPTY": "Il n'y a pour le moment aucune société dans ce secteur.",
	"SX_LANG_COMPANY_SURVEYS_LIST_EMPTY": "La liste des enquêtes est vide.",

	"SX_LANG_USER_INFO_EDIT": "Modifier",
	"SX_LANG_USER_INFO_EDITED": "Succès de la modification.",

	"SX_LANG_USERS_FIND": "Utilisateurs",

	"SX_LANG_SEARCH_WITH_COMPANY_NAME": "Nom de la société...",
	"SX_LANG_SEARCH_WITH_SURVEY_TITLE": "Titre du sondage...",
	"SX_LANG_SEARCH_SURVEYS_EMPTY": "Aucun sondage ne correspond à votre recherche.",
	"SX_LANG_SEARCH_COMPANIES_EMPTY": "Aucune entreprise ne correspond à votre recherche.",

	"SX_LANG_DELETE_CONFIRM": "Voulez-vous vraiment supprimer \"{name}\"?",
	"SX_LANG_SURVEY_DELETE_SUCCESS": "Le sondage a été supprimé avec succès.",
	"SX_LANG_SURVEY_DELETE_ERROR": "Erreur lors de la suppression du sondage.",

	"SX_LANG_COMPANY_DELETE_SUCCESS": "La société a été supprimée avec succès.",
	"SX_LANG_COMPANY_DELETE_ERROR": "Erreur lors de la suppression de la société.",

	"SX_LANG_SEARCH_INPUT_ERROR": "Veuillez entrer au moins {min} caractères minimum.",

	"SX_LANG_COMPANIES_FIND": "Sociétés",
	"SX_LANG_SURVEYS_FIND": "Sondage",
	"SX_LANG_ACCOUNT": "Compte",
	"SX_LANG_APP_NAME": "SondXpress",
	"SX_LANG_APP_SHARE": "Partager SondXpress",
	"SX_LANG_APP_SHARE_MESSAGE": "Salut, je t'invite à installer SondXpress depuis Android Play Store pour participer ou faire des enquêtes et sondages :\n{appUrl}",

} as tI18nDefinition;
